import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError, change, untouch } from 'redux-form'
import { saveInsurance, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import InsuranceForm from '../components/InsuranceForm.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteReduxFormField(fieldName){
            dispatch(change('InsuranceForm', fieldName, null));
            dispatch(untouch('InsuranceForm', fieldName));
        },
        setReduxFormField(fieldName, value){
            dispatch(change('InsuranceForm', fieldName, value));
        },
        saveInsurance(values, dispatch) {
            dispatch(submitForm())
            return dispatch(saveInsurance(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceForm);



/** WEBPACK FOOTER **
 ** ./src/containers/InsuranceFormContainer.js
 **/